import { render } from 'react-dom';

import App from './components/App';

import 'normalize.css';
import './index.css';

render(<App />, document.getElementById('root'));
